
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiBase as ObcPoiBaseElement} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi/poi-base.js';
 
 
 

 
 export const ObcPoiBase = createComponent({
   react: React,
   tagName: 'undefined',
   elementClass: ObcPoiBaseElement,
   events: {
     
   }
  });
 
 